import React, { useState } from 'react';
import StatsModal from './Stats.jsx';
import RulesModal from './Rules.jsx';
import SettingsModal from './Settings.jsx';
import Modal from './Modal.jsx';
import RulesDemo from './RulesDemo.jsx';
import { useGameMode } from '../../Providers/GameModes/GameModes.jsx';

function AllModals({
  isStatsOpen,
  setStatsOpen,
  isRulesOpen,
  setRulesOpen,
  isSettingsOpen,
  setSettingsOpen,
}) {
  const { gameMode } = useGameMode();
  const [isSampleOpen, setSampleOpen] = useState(false);

  const openSample = () => {
    setRulesOpen(false);
    setSampleOpen(true);
  };

  const closeSample = () => {
    setSampleOpen(false);
    setRulesOpen(true);
  };

  return (
    <div>
      <Modal
        isOpen={isRulesOpen}
        onClose={() => setRulesOpen(false)}
        title="HOW TO PLAY"
      >
        <RulesModal gameMode={gameMode} onTrySample={openSample} />
      </Modal>

      <Modal
        isOpen={isSampleOpen}
        onClose={closeSample}
        title="SAMPLE GAME"
        maxWidth="760px"
      >
        <RulesDemo gameMode={gameMode} standalone />
      </Modal>
      
      <Modal
        isOpen={isSettingsOpen}
        onClose={() => setSettingsOpen(false)}
        title="SETTINGS"
      >
        <SettingsModal />
      </Modal>
      
      <Modal
        isOpen={isStatsOpen}
        onClose={() => setStatsOpen(false)}
        title="STATS"
      >
        <StatsModal isOpen={isStatsOpen} />
      </Modal>
    </div>
  );
}

export default AllModals;
